module.exports = __webpack_public_path__ + "img/banner.d6feeb78.png";